(() => {
  const MIN_QTY = 4;

  function clampQty(q) {
    q = parseInt(q, 10);
    if (Number.isNaN(q) || q < MIN_QTY) return MIN_QTY;
    return q;
  }

  function setQtyUI() {
    // Covers most themes
    const inputs = document.querySelectorAll(
      'input[name="quantity"], quantity-input input, input.quantity__input'
    );

    inputs.forEach((input) => {
      input.setAttribute("min", String(MIN_QTY));
      input.setAttribute("step", "1");
      input.value = String(clampQty(input.value || MIN_QTY));
    });
  }

  function showMsgNear(el, text) {
    if (!el) return;
    let msg = el.parentElement?.querySelector(".min-qty-msg");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "min-qty-msg";
      msg.style.marginTop = "8px";
      msg.style.fontSize = "14px";
      el.insertAdjacentElement("afterend", msg);
    }
    msg.textContent = text;
  }

  // 1) Block normal form submits to /cart/add
  function bindFormGuards() {
    document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
      if (form.dataset.minQtyBound === "1") return;
      form.dataset.minQtyBound = "1";

      form.addEventListener("submit", (e) => {
        const qtyInput =
          form.querySelector('input[name="quantity"]') ||
          form.querySelector("quantity-input input") ||
          form.querySelector("input.quantity__input");

        if (!qtyInput) return;

        const qty = parseInt(qtyInput.value || "1", 10);
        if (Number.isNaN(qty) || qty < MIN_QTY) {
          e.preventDefault();
          e.stopPropagation();
          qtyInput.value = String(MIN_QTY);
          showMsgNear(qtyInput, `Minimum order is ${MIN_QTY} panels.`);
          qtyInput.focus();
        }
      }, true);
    });
  }

  // 2) Intercept AJAX add-to-cart requests (fetch)
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    try {
      const url = typeof input === "string" ? input : input?.url;

      // Shopify AJAX add endpoint
      if (url && url.includes("/cart/add")) {
        // If body is FormData (common in themes)
        if (init?.body instanceof FormData) {
          const fd = init.body;
          if (fd.has("quantity")) fd.set("quantity", String(clampQty(fd.get("quantity"))));
          else fd.set("quantity", String(MIN_QTY));
          init.body = fd;
        }

        // If body is JSON string
        if (typeof init?.body === "string") {
          try {
            const data = JSON.parse(init.body);
            if (data && typeof data === "object") {
              data.quantity = clampQty(data.quantity ?? MIN_QTY);
              init.body = JSON.stringify(data);
            }
          } catch (_) {}
        }
      }
    } catch (_) {}

    return originalFetch.apply(this, arguments);
  };

  // 3) Intercept XHR (some themes still use it)
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__minQtyUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    try {
      const url = this.__minQtyUrl || "";
      if (url.includes("/cart/add")) {
        if (body instanceof FormData) {
          if (body.has("quantity")) body.set("quantity", String(clampQty(body.get("quantity"))));
          else body.set("quantity", String(MIN_QTY));
        }
      }
    } catch (_) {}
    return origSend.apply(this, arguments);
  };

  function boot() {
    setQtyUI();
    bindFormGuards();
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);

  // Some themes render product form later
  new MutationObserver(() => boot()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();